"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import AppShell from "@/components/AppShell";

/**
 * Decide qué chrome envuelve a la página:
 * - Rutas /portal-contabilidad/* → no envuelve (el portal trae su propio Layout/Sidebar/Header).
 * - Rutas /tienda/* → no envuelve (tienda B2B con UI/UX propia tipo Shopify-lite).
 * - Resto → AppShell estándar de Cacique Agro (sin cambios visuales).
 *
 * Este switch existe para aislar 100% la UI/UX de portales especializados
 * sin tocar el AppShell ni el layout raíz.
 */
export default function AppShellSwitch({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  // /campo = App Shell SPA del módulo AGRO offline; trae su propio chrome móvil.
  if (pathname?.startsWith("/campo")) {
    return <>{children}</>;
  }
  if (pathname?.startsWith("/portal-contabilidad")) {
    return <>{children}</>;
  }
  // /conuco = módulo aislado de abastecimiento de tayota; chrome propio.
  if (pathname?.startsWith("/conuco")) {
    return <>{children}</>;
  }
  if (pathname?.startsWith("/tienda")) {
    return <>{children}</>;
  }
  return <AppShell>{children}</AppShell>;
}
